const validatePass = (rule, value, callback) => {
  let Reg = /^(?![0-9]+$)(?![a-zA-Z]+$)[0-9A-Za-z]{8,16}$/;
  if (value === "") {
    return callback(new Error("请输入密码"));
  } else {
    if (!Reg.test(value)) {
      return callback(new Error("请输入8-16位，同时包含数字和字母密码"));
    }
    return callback();
  }
};
const validateOld = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("请输入原密码"));
  } else {
    return callback()
  }
};
const validateQuestion = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("请输入登录密码"));
  } else {
    return callback()
  }
};
const validateSecret = (rule, value, callback) => {
  if (!value) {
    return callback(new Error("请输入登录密码"));
  } else {
    callback()
  }
};
export {
  validatePass,
  validateOld,
  validateQuestion,
  validateSecret
}